import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule } from 'devextreme-angular';
import { BookmarkNewComponent } from '../bookmark-new.component';
import { CreateBookmarkPopUpComponent } from '../create-bookmark-pop-up/create-bookmark-pop-up.component';
import { PopupControl } from 'src/app/models/popup-control.model';
import { BookmarksGroupOperator } from '../operators/bookmarks-group.operator';
import { BookmarkElementsOperator } from '../operators/elements-operators/bookmark-elements.operator';
import { BookmarksGroupDropDownComponent } from '../bookmarks-group-drop-down/bookmarks-group-drop-down.component';
import { Bookmark } from '../models/bookmark.model';
import { StatusMessageResultDto } from 'src/app/pages/general/project.service';
import { NotificationService } from 'src/app/services/notification.service';
import { confirm } from 'devextreme/ui/dialog';

@Component({
    selector: 'app-bookmarks-controls',
    imports: [
        CommonModule,
        BookmarkNewComponent,
        BookmarksGroupDropDownComponent,
        CreateBookmarkPopUpComponent,
        DxButtonModule,
    ],
    templateUrl: './bookmarks-controls.component.html',
    styleUrls: ['./bookmarks-controls.component.scss'],
	standalone: true
})
export class BookmarksControlsComponent {

	@ViewChild('bookmarksGroup', { static: false })
	public bookmarksGroup: BookmarkNewComponent;

	public createBookmarkPopupControl: PopupControl = new PopupControl(
		{
			title: 'Create Bookmark',
			width: 500,
			height: 'auto',
		}
	);

	@Input()
	public instanceIdentifier: number = null;

	@Input()
	public bookmarkElementsOperators: BookmarkElementsOperator[];

	@Input()
	public bookmarksGroupOperator: BookmarksGroupOperator;

	@Input()
	public initializeWithGenericOperator: boolean = true;

	public selectedBookmark: Bookmark;

	public updateSelectedBookmarkElements(): void {
		confirm('<div style="min-width: 244px;">Are you sure?</div>', 'Update Selected Bookmark').then(
			(value: boolean) => {
				if (value) {
					const promise$ = this.bookmarksGroupOperator.updateBookmarkElements(this.selectedBookmark);

					promise$.then(
						(statusMessageResultDto: StatusMessageResultDto) => {
							if (statusMessageResultDto.success) {
								this._notificationService.success('Bookmark successfully updated.');
							} else {
								this._notificationService.error('Issue encountered when updating bookmark. See console for more details.');

								console.error(statusMessageResultDto.message);
							}
						}
					);
				}
			}
		);
	}

	/**
	 *
	 */
	constructor(
		private _notificationService: NotificationService,
	) {}
}